<template>
    <div class="modal fade" 
        :id="modalID" 
        :aria-labelledby="theModalLabel" 
        tabindex="-1"
        aria-hidden="true"
        @click.self="close">

      <div class="np-base-dialog modal-dialog modal-dialog-centered">
        <div class="modal-content shadow">
          <div class="modal-header border-0 p-3 pb-2">
            <h5 class="modal-title">{{ position.id ? $t("UI.employee.editPosition") : $t("UI.employee.addPosition") }}</h5>
            <button type="button" class="np-btn np-outline" data-bs-dismiss="modal" aria-label="Close">
                <svg><use href="@/assets/images/icons/close3.svg#icon"></use></svg> 
            </button> 
          </div>
          <div class="modal-body p-3 mt-4 mb-4">
            <div class="mb-4">
              <label class="np-font-m np-f-medium mb-1">{{ $t("UI.employee.position") }}</label>
              <input type="text" class="form-control np-input" aria-describedby="departmentHelp" v-model="position.name">
              <small class="form-text text-muted">{{ error }}</small>
            </div>
            <div class="mb-4">
              <textarea class="form-control np-textarea has-text-weight-bold flex-grow-1" id="taskTitle" autocomplete="off" 
                  v-model="position.description" :placeholder="$t('UI.employee.positionDesc')"></textarea>                     
            </div>            
          </div>
          <div class="modal-footer p-3">
            <button type="button" class="np-btn np-danger px-4 me-1" data-bs-dismiss="modal">{{ $t("UI.close") }}</button>
            <button type="button" class="np-btn np-success-filled px-4" @click="onConfirm">{{ $t("UI.save") }}</button>
          </div>
        </div>
      </div>
    </div>
  </template>
  
<script>
  import { useOrganizationStore } from '@/stores/organizationStore'
  import { Modal } from "bootstrap"

  export default {
    props: {
        modalID: {
          type: String,
          required: true
        }   
    },
    data() {
      return {
        theModal: null,
        theModalLabel: null,   
        position: {
          id: null,     
          name: '',
          description: ''
        },
        error: '',
        isError: false
      }
    },
    mounted: function () {
      var IdModal = '#' + this.$props.modalID
      this.theModalLabel = this.modalID + "Label"
      this.theModal = new Modal(IdModal, {backdrop: true})        
    },     
    computed: {
      organizationStore() {
          return useOrganizationStore()
      }      
    },
    methods: {
      shows(data) {
        if (data) {
          this.position = {... data}
        } else {
          this.position.id = null
          this.position.name = ''
          this.position.description = ''
        }
        this.theModal.show()
      },
      hide() {
          this.theModal.hide()
      },      
      onConfirm() {
        if (this.name == "") {
          isError = true
        } else {
          this.organizationStore.updatePosition(this.position)

          this.hide()
        }
      }
    }
  }
  </script>